import React, { useEffect, useState } from "react";
import { errorMessage } from "Utils/useRequest";
import usePromiseCallback from "Utils/usePromiseCallback";
import { InTheSign, SignType } from "API/signIn";
import { Input, Modal, Spin } from "antd";
import style from "./index.module.scss";

interface SignInputProps {
    type: SignType;
    signInId: number;
    onComplete: () => void;
}

export default function SignInput({
    type,
    signInId,
    onComplete
}: SignInputProps) {
    const [random, setRandom] = useState(0);
    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState("");

    const doSubmit = usePromiseCallback(async (str?: string) => {
        try {
            setLoading(true);
            await InTheSign(signInId, str || code);
            onComplete();
        } catch (e) {
            Modal.error({
                content: errorMessage(e),
                onOk: () => setRandom(Math.random())
            });
        } finally {
            setLoading(false);
        }
    });

    // 普通签到自动签
    useEffect(() => {
        if (type === SignType.Normal) {
            doSubmit("");
        }
    }, [type]);

    if (type === SignType.Normal)
        return (
            <Spin>
                <div className={style.root} />
            </Spin>
        );

    function checkCode(str: string) {
        const reg = /^[0-9]\d*$|^0$/;

        if (str === "") {
            setCode(str);
        }

        if (str.length <= 4 && reg.test(str)) {
            setCode(str);
        }

        if (str.length === 4) {
            doSubmit(str);
        }
    }

    function onPressEnter() {
        if (code.length === 4) {
            doSubmit();
        }
    }

    return (
        <div className={style.root}>
            <Spin spinning={loading}>
                <div className={style.tip}>
                    友情提示：请输入投影幕显示的数字码
                </div>

                <div className={style.input}>
                    <Input
                        placeholder="请输入四位签到码"
                        type="number"
                        key={random}
                        value={code}
                        onPressEnter={onPressEnter}
                        onChange={e => checkCode(e.target.value)}
                    />
                    {/*<Button*/}
                    {/*    disabled={code.length !== 4}*/}
                    {/*    onClick={doSubmit}*/}
                    {/*    className={style.btn}*/}
                    {/*    type="primary">*/}
                    {/*    输入完毕*/}
                    {/*</Button>*/}
                </div>
            </Spin>
        </div>
    );
}
